import { render, staticRenderFns } from "./UserTaskDetails.vue?vue&type=template&id=cb41f0e2&"
import script from "./UserTaskDetails.vue?vue&type=script&lang=js&"
export * from "./UserTaskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports